import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ServicesPage from './components/ServicesPage';
import ServiceDetailPage from './components/ServiceDetailPage';
import ServiceLandingPage from './components/ServiceLandingPage';
import GalleryPage from './components/GalleryPage';
import InquiryPage from './components/InquiryPage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import EmployeeLogin from './components/EmployeeLogin';
import EmployeeDashboard from './components/EmployeeDashboard';
import ClientReviewsPage from './components/ClientReviewsPage';
import FloatingLeadCTA from './components/FloatingLeadCTA';
import './App.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <FloatingLeadCTA />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/service/:serviceSlug" element={<ServiceLandingPage />} />
        <Route path="/valet-parking-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/facility-management-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/manpower-services-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/office-boy-services-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/peon-services-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/labour-supply-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/housekeeping-services-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/cleaning-services-ahmedabad" element={<ServiceLandingPage />} />
        <Route path="/client-reviews-ahmedabad" element={<ClientReviewsPage />} />
        <Route path="/testimonials" element={<Navigate to="/client-reviews-ahmedabad" replace />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/inquiry" element={<InquiryPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/employee/login" element={<EmployeeLogin />} />
        <Route path="/employee" element={<EmployeeDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
